import { yup } from '@framework/validation';
import { ExpressionType } from '../../IExpression';
import { DefaultAssignableExpressionSchema } from '../assignable/AssignableExpressionSchema';
import { ConditionGroupExpressionSchema } from '../condition-group/ConditionGroupExpressionSchema';
import { ISwitchExpression, ISwitchExpressionCase } from './ISwitchExpression';

/**
 * Schema di validazione per un singolo caso di uno switch (condizione -> risultato/valore)
 */
export const SwitchExpressionCaseSchema: yup.ObjectSchema<ISwitchExpressionCase> =
  yup
    .object({
      condition: ConditionGroupExpressionSchema.required().label('Condizione'),
      value: DefaultAssignableExpressionSchema,
    })
    .required();

export const SwitchExpressionSchema: yup.ObjectSchema<ISwitchExpression> = yup
  .object({
    type: yup
      .string()
      .exact(ExpressionType.Switch)
      .required()
      .transform(() => ExpressionType.Switch),
    cases: yup
      .array()
      .of(SwitchExpressionCaseSchema)
      .required()
      .default([])
      .label('Lista condizioni'),
    defaultValue: DefaultAssignableExpressionSchema,
  })
  .meta({ expression: ExpressionType.Switch });
